module.exports = __webpack_public_path__ + "fonts/Nunito-Variable.bcfaf5e.woff2";